import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import CloseVirtualCardContent from 'src/app/CloseVirtualCardContent/CloseVirtualCardContent'
import {
  selectVirtualCard,
  selectVirtualCardIdFromRoute,
} from 'src/app/CloseVirtualCardContent/redux/closeVirtualCardContent.selectors'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { closeBillPayCardUrl } from 'src/navigation/urls'
import {
  getVirtualCard,
  getVirtualCardPermissions,
} from 'src/redux/actions/data/virtualCards.actions'

const CloseVirtualCard: React.FC = (): React.ReactElement => {
  const dispatch = useFlyoutDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const virtualCard = useSelector(selectVirtualCard)

  useEffect((): void => {
    dispatch(getVirtualCard(virtualCardId))
    dispatch(getVirtualCardPermissions(virtualCardId))
  }, [virtualCard?.status, virtualCardId])

  useEffect(() => {
    if (virtualCard === undefined) return

    if (virtualCard.isBillPay) {
      // user is trying to access a bill pay card, redirect to the bill pay url
      dispatch(connectedReplace(closeBillPayCardUrl(virtualCardId)))
    }
  }, [virtualCard])

  return (
    <CloseVirtualCardContent
      virtualCardId={virtualCardId}
      virtualCard={virtualCard}
    />
  )
}

export default CloseVirtualCard
